import { gql } from '@apollo/client';

export const CLARKE_CLIENTS_REPORT_QUERY = gql`
  query GetClarkeClientsReport(
    $page: Int
    $limit: Int
    $term: String
    $nameFilter: String
    $legalNameFilter: String
    $accountManagerIdFilter: String
    $docTypeFilter: String
    $docNumberFilter: String
    $companyIdFilter: String
    $clientIdFilter: String
    $status: LifecycleStatus
    $statusIsNull: Boolean
    $companyType: Int
    $exposure: Int
    $volumeMwmMin: Float
    $volumeMwmMax: Float
    $exposurePercentageMin: Float
    $exposurePercentageMax: Float
    $unitsCountMin: Int
    $unitsCountMax: Int
    $clientSinceFrom: String
    $clientSinceTo: String
    $churnDateFrom: String
    $churnDateTo: String
    $createdAtFrom: String
    $createdAtTo: String
    $updatedAtFrom: String
    $updatedAtTo: String
    $sortBy: String
    $sortOrder: String
    $nullKpi: String
  ) {
    clarkeClientsReport(
      page: $page
      limit: $limit
      term: $term
      nameFilter: $nameFilter
      legalNameFilter: $legalNameFilter
      accountManagerIdFilter: $accountManagerIdFilter
      docTypeFilter: $docTypeFilter
      docNumberFilter: $docNumberFilter
      companyIdFilter: $companyIdFilter
      clientIdFilter: $clientIdFilter
      status: $status
      statusIsNull: $statusIsNull
      companyType: $companyType
      exposure: $exposure
      volumeMwmMin: $volumeMwmMin
      volumeMwmMax: $volumeMwmMax
      exposurePercentageMin: $exposurePercentageMin
      exposurePercentageMax: $exposurePercentageMax
      unitsCountMin: $unitsCountMin
      unitsCountMax: $unitsCountMax
      clientSinceFrom: $clientSinceFrom
      clientSinceTo: $clientSinceTo
      churnDateFrom: $churnDateFrom
      churnDateTo: $churnDateTo
      createdAtFrom: $createdAtFrom
      createdAtTo: $createdAtTo
      updatedAtFrom: $updatedAtFrom
      updatedAtTo: $updatedAtTo
      sortBy: $sortBy
      sortOrder: $sortOrder
      nullKpi: $nullKpi
    ) {
      page
      total
      limit
      indicators {
        totalCompanies
        totalVolumeMwm
        totalUnits
        nullKpis {
          name
          legalName
          docType
          docNumber
          type
          status
          unitsCount
          volumeMwm
          exposure
          exposurePercentage
        }
      }
      data {
        id
        name
        legalName
        docType
        docNumber
        clientId
        clientName
        type
        status
        unitsCount
        volumeMwm
        exposure
        exposurePercentage
        clientSince
        churnDate
        createdAt
        updatedAt
        organizationId
      }
    }
  }
`;

export const CLARKE_CLIENTS_REPORT_FILTER_VALUES_QUERY = gql`
  query GetClarkeClientsReportFilterValues($field: String!) {
    clarkeClientsReportFilterValues(field: $field) {
      values
      hasEmpty
    }
  }
`;
